import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl, FormLabel,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addDoctor, fetchSpecialtiesList } from "../../Adapters/ApiAdapter";
import { baseUrl } from "../../variables/Variables";
import ReactQuill from "react-quill";
import CKEditorField from "../../components/CKEditorField";

const AddDoctors = () => {
  const [formData, setFormData] = useState({
    name_prefix: "",
    name: "",
    slug: "",
    description: "",
    education: "",
    // speciality_id: "",
    speciality_ids: [],
    profile_picture: null, // For image upload
    banner_img: "",
    experience: "",
    designation: "",
    department: "",
    special_interest: "",
    display_order: "",
    video_link: "",
    meta_title: "",
    meta_description: "", // New experience field
    meta_keywords: "",
    custom_scripts: "",
    seo_title: "",
    canonical_link: "",
    og_locale: "",
    og_site_name: "",
    og_image_width: "",
    og_image_height: "",
    og_image_type: "",
    article_modified_time: "",
    og_title: "",
    og_description: "",
    og_type: "",
    og_url: "",
    og_image: "",
    twitter_card: "",
    twitter_title: "",
    twitter_description: "",
    twitter_site: "",
    twitter_image: "",
    days: "",
    timing: "",
    display_order: "",
    file: "",
  });
  const [specialities, setSpecialities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [loadingSpecialities, setLoadingSpecialities] = useState(true);
  const navigate = useNavigate();

  // Fetch specialities on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchSpecialtiesList();
        if (response && response.specialities) {
          const sortedSpecialities = response.specialities.sort((a, b) =>
            a.name.localeCompare(b.name)
          );
          setSpecialities(sortedSpecialities);
        } else {
          toast.error("Failed to load specialities.");
        }
      } catch (error) {
        toast.error("Error fetching specialities.");
      } finally {
        setLoadingSpecialities(false);
      }
    };

    fetchData();
  }, []);

 // const handleInputChange = (e) => {
 //   const { name, value } = e.target;
 //   if (name === "name") {
 //     setFormData((prev) => ({
 //       ...prev,
 //       name: value,
 //       slug: generateSlug(value),
 //     }));
 //   } else {
 //     setFormData({ ...formData, [name]: value });
 //   }
 // };
	
    const handleInputChange = (e) => {
  const { name, value } = e.target;

  // Update the relevant field
  setFormData((prev) => {
    const updated = { ...prev, [name]: value };

    // Generate slug when either prefix or name changes
    if (name === "name" || name === "name_prefix") {
      const fullName = `${updated.name_prefix} ${updated.name}`.trim();
      updated.slug = generateSlug(fullName);
    }

    return updated;
  });
};


  // const handleFileChange = (e, field) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setUploading(true);
  //     // Simulate delay or do your actual logic here
  //     setTimeout(() => {
  //       setFormData((prev) => ({ ...prev, [field]: file }));
  //       setUploading(false);
  //     }, 1000); // simulate file processing delay
  //   }
  // };
  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      setUploading(true);

      const timestamp = Date.now();
      const extension = file.name.split('.').pop();
      const baseName = file.name.replace(/\.[^/.]+$/, "");
      const newFileName = `${baseName}_${timestamp}.${extension}`;

      const newFile = new File([file], newFileName, {
        type: file.type,
        lastModified: new Date().getTime(),
      });

      // Simulate delay or process logic
      setTimeout(() => {
        setFormData((prev) => ({ ...prev, [field]: newFile }));
        setUploading(false);
      }, 1000);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/&/g, " ")
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const doctorData = new FormData();
 
  //  for (let key in formData) {
  //    if (
  //      [
  //        "description",
  //        "education",
  //        "designation",
  //        "meta_description",
  //        "custom_scripts",
  //        "og_description",
  //        "twitter_description",
  //      ].includes(key)
  //    ) {
  //       doctorData.append(key, formData[key]);
  //      if (key === "speciality_ids") {
  //       formData.speciality_ids.forEach((id) => {
  //         doctorData.append("speciality_ids[]", id);
  //       });
  //      } else {
  //        doctorData.append(key, formData[key]);
  //      }
  //    } else if (key === "display_order") {
        // Only append if value is present
  //      if (formData.display_order !== "") {
  //        doctorData.append("display_order", parseInt(formData.display_order));
  //      }
  //    }
  //    else {
   //     doctorData.append(key, formData[key]);
   //   }
  //  }
	  //
    formData.speciality_ids.forEach((id) => {
      doctorData.append("speciality_ids[]", id);
    });

    for (let key in formData) {
      if (key === "speciality_ids") continue;
      if (key === "display_order" && formData.display_order !== "") {
        doctorData.append("display_order", parseInt(formData.display_order));
      } else if (formData[key] !== null && formData[key] !== undefined) {
        doctorData.append(key, formData[key]);
      }
    }

    try {
      const response = await addDoctor(doctorData);
      if (response && response.status === "true") {
        toast.success("Doctor added successfully!");
        setFormData({
          name_prefix: "",
          name: "",
          slug: "",
          description: "",
          speciality_ids: [],
          profile_picture: null,
          experience: "",
          designation: "",
          special_interest: "",
          department: '',
          video_link: '',
          display_order: '',
          days: '',
          timing: '',

          meta_title: "",
          meta_description: "",
          meta_keywords: "",
          custom_scripts: "",
          seo_title: "",
          canonical_link: "",
          og_locale: "",
          og_site_name: "",
          og_image_width: "",
          og_image_height: "",
          og_image_type: "",
          article_modified_time: "",
          og_title: "",
          og_description: "",
          og_type: "",
          og_url: "",
          og_image: "",
          twitter_card: "",
          twitter_title: "",
          twitter_description: "",
          twitter_site: "",
          twitter_image: "",
          // days: "",
          // start_time: "",
          // end_time: "",
          // appointment_status: "",
          // status: "",
          file: "",
        });
        setTimeout(() => {
          navigate("/list-doctors");
        }, 1500);
      }
      else {
        const errorMessage = response?.error || response?.message || "Failed to add doctor.";
        toast.error(errorMessage);
      }
    } catch (error) {
      toast.error("An error occurred while adding the doctor.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box m="20px">
      <ToastContainer />
      <Typography variant="h4" gutterBottom>
        Add Doctor
      </Typography>
      <form onSubmit={handleSubmit}>
        {/* Name Prefix Dropdown */}
        {/* <FormControl fullWidth className="mb-4">
          <InputLabel id="name-prefix-label">Name Prefix</InputLabel>
          <Select
            labelId="name-prefix-label"
            id="name_prefix"
            name="name_prefix"
            value={formData.name_prefix || ''}
            onChange={handleChange}
            label="Name Prefix"
          >
            {["Dr.", "Prof.", "Mr.", "Ms.", "Mrs."].map((prefix) => (
              <MenuItem key={prefix} value={prefix}>{prefix}</MenuItem>
            ))}
          </Select>
        </FormControl> */}
        <TextField
          fullWidth
          margin="normal"
          label="Name Prefix"
          name="name_prefix"
          value={formData.name_prefix || ""}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              name_prefix: e.target.value,
            }))
          }
        />
        <TextField
          style={{ marginBottom: "30px" }}
          fullWidth
          margin="normal"
          label="Name"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          required
        />
        <TextField
          style={{ marginBottom: "30px" }}
          fullWidth
          margin="normal"
          label="Slug"
          name="slug"
          value={formData.slug}
          onChange={handleInputChange}
          required
        />
        <Typography variant="body1"> Description</Typography>
        {/* <ReactQuill
          theme="snow"
          value={formData.description}
          onChange={(value) => setFormData({ ...formData, description: value })}
          style={{ height: "200px", marginBottom: "50px" }}
        /> */}
        <CKEditorField
            value={formData.description}
            onChange={(data) => setFormData((prev) => ({ ...prev, description: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=doctors`}
          />
        <Typography variant="body1">Education</Typography>
        {/* <ReactQuill
          theme="snow"
          value={formData.education}
          onChange={(value) => setFormData({ ...formData, education: value })}
          style={{ height: "200px", marginBottom: "50px" }}
        /> */}
        <CKEditorField
            value={formData.education}
            onChange={(data) => setFormData((prev) => ({ ...prev, education: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=doctors`}
          />

        {loadingSpecialities ? (
          <CircularProgress size={24} />
        ) : (
          // <FormControl fullWidth margin="normal">
          //   <InputLabel id="speciality-label">Speciality</InputLabel>
          //   <Select
          //     labelId="speciality-label"
          //     name="speciality_id"
          //     value={formData.speciality_id}
          //     onChange={handleInputChange}
          //     required
          //   >
          //     {specialities.map((speciality) => (
          //       <MenuItem key={speciality.id} value={speciality.id}>
          //         {speciality.name}
          //       </MenuItem>
          //     ))}
          //   </Select>
          // </FormControl>
          <FormControl fullWidth margin="normal">
            <InputLabel id="speciality-label">Specialities *</InputLabel>
            <Select
              labelId="speciality-label"
              name="speciality_ids"
              label="Specialities"
              multiple
              value={formData.speciality_ids}
              onChange={(e) =>
                setFormData((prev) => ({ ...prev, speciality_ids: e.target.value }))
              }
              renderValue={(selected) =>
                specialities
                  .filter((s) => selected.includes(s.id))
                  .map((s) => s.name)
                  .join(', ')
              }
              required
            >
              {specialities.map((speciality) => (
                <MenuItem key={speciality.id} value={speciality.id}>
                  <input
                    type="checkbox"
                    checked={formData.speciality_ids.includes(speciality.id)}
                    readOnly
                  />
                  <span style={{ marginLeft: 8 }}>{speciality.name}</span>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <TextField
          style={{ marginBottom: "30px" }}
          fullWidth
          margin="normal"
          label="Experience (in years)"
          name="experience"
          type="number"
          value={formData.experience}
          onChange={handleInputChange}
          required
        />
        <Typography variant="body1">Designation</Typography>
        {/* <ReactQuill
          theme="snow"
          value={formData.designation}
          onChange={(value) => {
            setFormData((prev) => ({ ...prev, designation: value }));
          }}
          style={{ height: "200px", marginBottom: "50px" }}
        /> */}
        <CKEditorField
            value={formData.designation}
            onChange={(data) => setFormData((prev) => ({ ...prev, designation: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=doctors`}
          />
        <TextField
          fullWidth
          label="Department"
          name="department"
          value={formData.department || ''}
          onChange={handleChange}
          className="mb-4"
        />
        <Typography variant="body1">Areas of Expertise</Typography>
        {/* <ReactQuill
          theme="snow"
          value={formData.special_interest}
          onChange={(value) =>
            setFormData((prev) => ({ ...prev, special_interest: value }))
          }
          style={{ height: "200px", marginBottom: "50px" }}
        /> */}
        <CKEditorField
            value={formData.special_interest}
            onChange={(data) => setFormData((prev) => ({ ...prev, special_interest: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=doctors`}
          />

        {/* <TextField
          style={{ marginBottom: "20px" }}
          margin="normal"
          fullWidth
          label="OPD Days"
          name="days"
          value={formData.days}
          onChange={handleInputChange}
        />

        <Typography variant="body1">Start Time</Typography>

        <TextField
          style={{ marginBottom: "20px" }}
          margin="normal"
          fullWidth
          type="time"
          name="start_time"
          value={formData.start_time}
          onChange={handleInputChange}
          InputLabelProps={{ shrink: true }}
          inputProps={{ step: 300 }}
        />
        <Typography variant="body1">End Time</Typography>
        <TextField
          style={{ marginBottom: "20px" }}
          margin="normal"
          fullWidth
          type="time"
          name="end_time"
          value={formData.end_time}
          onChange={handleInputChange}
          InputLabelProps={{ shrink: true }}
          inputProps={{ step: 300 }}
        /> */}
        {/* OPD Days - Rich Text */}
        <FormLabel className="mb-2">OPD Days</FormLabel>
        {/* <ReactQuill
          theme="snow"
          value={formData.days || ''}
          onChange={(value) => setFormData((prev) => ({ ...prev, days: value }))}
          className="mb-4"
          style={{ height: "200px", marginBottom: "50px" }}
          placeholder={`Example:\nMonday - Tuesday\nWednesday - Friday`}
        /> */}
        <CKEditorField
            value={formData.days}
            onChange={(data) => setFormData((prev) => ({ ...prev, days: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=doctors`}
          />

        {/* OPD Timing - Rich Text */}
        <FormLabel className="mb-2">OPD Timings</FormLabel>
        {/* <ReactQuill
          theme="snow"
          value={formData.timing || ''}
          onChange={(value) => setFormData((prev) => ({ ...prev, timing: value }))}
          className="mb-4"
          style={{ height: "200px", marginBottom: "50px" }}
          placeholder={`Example:\n10:00 AM - 02:00 PM\n02:00 PM - 08:00 PM`}
        /> */}
        <CKEditorField
            value={formData.timing}
            onChange={(data) => setFormData((prev) => ({ ...prev, timing: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=doctors`}
          />

        {/* <TextField
          style={{ marginBottom: "20px" }}
          margin="normal"
          fullWidth
          label="appointment_status"
          name="appointment_status"
          value={formData.appointment_status}
          onChange={handleInputChange}
        /> */}

        <TextField
          style={{ marginBottom: "30px" }}
          fullWidth
          label="Video Link"
          name="video_link"
          value={formData.video_link || ''}
          onChange={handleChange}
          className="mb-4"
        />

        <TextField
          fullWidth
          style={{ marginBottom: "10px" }}
          label="Display Order"
          name="display_order"
          type="number"
          value={formData.display_order}
          onChange={handleInputChange}
        />

        <TextField
          style={{ marginBottom: "10px" }}
          margin="normal"
          fullWidth
          label="SEO Title"
          name="seo_title"
          value={formData.seo_title}
          onChange={handleInputChange}
        />

        <TextField
          style={{ marginBottom: "30px" }}
          fullWidth
          margin="normal"
          label="Meta Title"
          name="meta_title"
          value={formData.meta_title}
          onChange={handleInputChange}
        />
        <Typography variant="body1">meta_description</Typography>
        {/* <ReactQuill
          theme="snow"
          value={formData.meta_description}
          onChange={(value) => {
            setFormData((prev) => ({ ...prev, meta_description: value }));
          }}
          style={{ height: "200px", marginBottom: "60px" }}
        /> */}
        <CKEditorField
            value={formData.meta_description}
            onChange={(data) => setFormData((prev) => ({ ...prev, meta_description: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=doctors`}
          />

        <TextField
          style={{ marginBottom: "30px" }}
          fullWidth
          margin="normal"
          label="meta_keywords"
          name="meta_keywords"
          value={formData.meta_keywords}
          onChange={handleInputChange}
        />

	  
	  {/*  <Typography variant="body1">Custom_Scripts</Typography>
        <ReactQuill
          theme="snow"
          value={formData.custom_scripts}
          onChange={(value) => {
            setFormData((prev) => ({ ...prev, custom_scripts: value }));
          }}
          style={{ height: "200px", marginBottom: "60px" }}
        /> */} 

	  <TextField
          label="Custom Scripts"
          name="custom_scripts"
          value={formData.custom_scripts}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, custom_scripts: e.target.value }))
          }
          fullWidth
          multiline
          minRows={10}
          maxRows={30}
          variant="outlined"
          style={{ marginBottom: "60px" }}
          placeholder={`Paste raw script here. Example:
          <script type="application/ld+json">
          { "jsonld": "data" }
          </script>`}
        />

        <TextField
          style={{ marginBottom: "20px" }}
          margin="normal"
          fullWidth
          label="canonical_link"
          name="canonical_link"
          value={formData.canonical_link}
          onChange={handleInputChange}
        />
        <TextField
          style={{ marginBottom: "20px" }}
          margin="normal"
          fullWidth
          label="og_title"
          name="og_title"
          value={formData.og_title}
          onChange={handleInputChange}
        />
        <TextField
          style={{ marginBottom: "20px" }}
          margin="normal"
          fullWidth
          label="og_locale"
          name="og_locale"
          value={formData.og_locale}
          onChange={handleInputChange}
        />
        <TextField
          style={{ marginBottom: "20px" }}
          margin="normal"
          fullWidth
          label="og_site_name"
          name="og_site_name"
          value={formData.og_site_name}
          onChange={handleInputChange}
        />
        <TextField
          style={{ marginBottom: "20px" }}
          margin="normal"
          fullWidth
          label="og_image_width"
          name="og_image_width"
          value={formData.og_image_width}
          onChange={handleInputChange}
        />
        <TextField
          style={{ marginBottom: "20px" }}
          margin="normal"
          fullWidth
          label="og_image_height"
          name="og_image_height"
          value={formData.og_image_height}
          onChange={handleInputChange}
        />
        <TextField
          style={{ marginBottom: "20px" }}
          margin="normal"
          fullWidth
          label="og_image_type"
          name="og_image_type"
          value={formData.og_image_type}
          onChange={handleInputChange}
        />
        <Typography variant="body1">article_modified_time</Typography>
        <TextField
          style={{ marginBottom: "20px" }}
          margin="normal"
          fullWidth
          type="datetime-local"
          label=""
          name="article_modified_time"
          value={formData.article_modified_time}
          onChange={handleInputChange}
        />

        <Typography variant="body1">og_description</Typography>
        {/* <ReactQuill
          theme="snow"
          value={formData.og_description}
          onChange={(value) => {
            setFormData((prev) => ({ ...prev, og_description: value }));
          }}
          style={{ height: "200px", marginBottom: "60px" }}
        /> */}
        <CKEditorField
            value={formData.og_description}
            onChange={(data) => setFormData((prev) => ({ ...prev, og_description: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=doctors`}
          />

        <TextField
          style={{ marginBottom: "20px" }}
          margin="normal"
          fullWidth
          label="og_type"
          name="og_type"
          value={formData.og_type}
          onChange={handleInputChange}
        />
        <TextField
          style={{ marginBottom: "20px" }}
          margin="normal"
          fullWidth
          label="og_url"
          name="og_url"
          value={formData.og_url}
          onChange={handleInputChange}
        />
        <TextField
          style={{ marginBottom: "20px" }}
          margin="normal"
          fullWidth
          label="twitter_title"
          name="twitter_title"
          value={formData.twitter_title}
          onChange={handleInputChange}
        />

        <TextField
          style={{ marginBottom: "20px" }}
          margin="normal"
          fullWidth
          label="twitter_card"
          name="twitter_card"
          value={formData.twitter_card}
          onChange={handleInputChange}
        />

        <Typography variant="body1">twitter_description</Typography>
        {/* <ReactQuill
          theme="snow"
          value={formData.twitter_description}
          onChange={(value) => {
            setFormData((prev) => ({ ...prev, twitter_description: value }));
          }}
          style={{ height: "200px", marginBottom: "60px" }}
        /> */}
        <CKEditorField
            value={formData.twitter_description}
            onChange={(data) => setFormData((prev) => ({ ...prev, twitter_description: data }))}
            uploadUrl={`${baseUrl}api/ck-editor-upload?folder=doctors`}
          />

        <TextField
          style={{ marginBottom: "20px" }}
          margin="normal"
          fullWidth
          label="twitter_site"
          name="twitter_site"
          value={formData.twitter_site}
          onChange={handleInputChange}
        />

        {/* <TextField
          style={{ marginBottom: "20px" }}
          margin="normal"
          fullWidth
          label="status"
          name="status"
          value={formData.status}
          onChange={handleInputChange}
        /> */}

        {/* <Button
          variant="contained"
          component="label"
          style={{ marginTop: "20px" }}
        >
          Upload Profile Picture
          <input
            type="file"
            accept="image/*"
            hidden
            onChange={(e) => handleFileChange(e, "profile_picture")}
          />
        </Button>
        {formData.profile_picture && (
          <Typography
            variant="body2"
            style={{ marginTop: "10px", fontStyle: "italic" }}
          >
            Selected File: {formData.profile_picture.name}
          </Typography>
        )} */}
        <Box mt={2}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            Upload Profile Picture <strong>(300x300px recommended)</strong>
          </Typography>
          <Button variant="contained" component="label"
            disabled={uploading}
            startIcon={uploading ? <CircularProgress size={20} /> : null}>
            {uploading ? "Uploading..." : "Choose File"}
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={(e) => handleFileChange(e, "profile_picture")}
            />
          </Button>
          {formData.profile_picture && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              Selected File: {formData.profile_picture.name}
            </Typography>
          )}
        </Box>

        <Box mt={3}>
          <Button variant="contained" component="label" sx={{ mt: 2 }}>
            Upload Banner Image
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={(e) => handleFileChange(e, "banner_img")}
            />
          </Button>
          {formData.banner_img && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              Selected: {formData.banner_img.name}
            </Typography>
          )}
          <br /><Typography variant="caption" color="textSecondary" style={{ color: 'red' }}>
            Banner Image should be 1380x260px
          </Typography>
        </Box>

        <Box mt={3}>
          <Button variant="contained" component="label" sx={{ mt: 2 }}>
            Upload OG Image
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={(e) => handleFileChange(e, "og_image")}
            />
          </Button>
          {formData.og_image && (
            <Typography
              variant="body2"
              style={{ marginTop: "10px", fontStyle: "italic" }}
            >
              Selected OG Image:{formData.og_image.name}
            </Typography>
          )}
        </Box>

        {/* <Box mt={3}>
          <Button variant="contained" component="label" sx={{ mt: 2 }}>
            Upload Twitter Card
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={(e) => handleFileChange(e, "twitter_card")}
            />
          </Button>
          {formData.twitter_card && (
            <Typography
              variant="body2"
              style={{ marginTop: "10px", fontStyle: "italic" }}
            >
              Selected twitter Card:{formData.twitter_card.name}
            </Typography>
          )}
        </Box> */}

        <Box mt={3}>
          <Button variant="contained" component="label" sx={{ mt: 2 }}>
            Upload Twitter Image
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={(e) => handleFileChange(e, "twitter_image")}
            />
          </Button>
          {formData.twitter_image && (
            <Typography
              variant="body2"
              style={{ marginTop: "10px", fontStyle: "italic" }}
            >
              Selected Twitter Image:{formData.twitter_image.name}
            </Typography>
          )}
        </Box>

        {/* <Box mt={3}>
          <Button variant="contained" component="label" sx={{ mt: 2 }}>
            Upload File
            <input
              type="file"
              hidden
              onChange={(e) => handleFileChange(e, "file")}
            />
          </Button>
          {formData.file && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              Selected: {formData.file.name}
            </Typography>
          )}
        </Box> */}

        <Box mt={3}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading || uploading}
            style={{ background: '#0ca854' }}
          >
            {loading ? <CircularProgress size={24} /> : "Add Doctor"}
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default AddDoctors;
